import { AddOutlined, DeleteOutline, EditOutlined } from "@mui/icons-material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, CustomButton, TableData } from "../../../../components";


import { confirmAlert, errorAlert } from "../../../../helpers/alerts";
import { Grid } from "@mui/material";
import { removePDSSegment, setCurrentPDSSegment, updatePDSSegment } from "redux/slices/admin/productSlice";
import { removePDSSegmentService, updatePDSSegmentService } from "services/admin/productService";
import { validatePermission } from "helpers/authentication";
import { Box } from "@mui/system";

const SegmentsPaymentServiceScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pdsSegments } = useSelector((state) => state.products);

  const handlerAdd = () => navigate("crear");

  const handlerEdit = (row) => {
    dispatch(setCurrentPDSSegment(row));
    navigate("editar");
  };

  const handlerCheck = async ({ id }, currentValue, col) => {
    const value = !currentValue;
    updatePDSSegmentService(id, { [col]: value })
      .then(() => dispatch(updatePDSSegment({ id, data: { [col]: value } })))
      .catch(error => errorAlert(error))

  };

  const handlerDelete = ({ id, name }) => {
    confirmAlert({
      title: "Estas seguro que deseas eliminar este segmento?",
      text: `El segmento ${name} será eliminado.`,
      onConfirm: async () => {
        try {
          await removePDSSegmentService(id);
          dispatch(removePDSSegment(id));
        }
        catch (error) {
          errorAlert(error)
        }
      }
    })
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="title">Pago de Servicios</div>
          <div className="subtitle">Segmentos</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Box mt={-5} >
        <TableData
          dataRows={pdsSegments}
          dataTitle={["Logo", "Nombre", "Estado"]}
          headerButtons={[
            validatePermission('productos', 'productos', ['agregar']) &&
            <CustomButton
              dark={true}
              icon={<AddOutlined />}
              key="addSegment"
              name={"Segmento"}
              click={handlerAdd}
            />,
          ]}
          formatter={({ name, state, fd }) => [
            { type: "img", value: `/v3/file/${fd}/` },
            name,
            { name: "state", type: "boolean", value: state },
          ]}
          onChecked={handlerCheck}
          actions={[
            {
              label: "Editar",
              icon: <EditOutlined />,
              onClick: (data) => {
                handlerEdit(data);
              },
            },
            {
              label: "Eliminar",
              icon: <DeleteOutline />,
              onClick: (data) => {
                handlerDelete(data);
              },
            },
          ]}
        />
      </Box>
    </>
  );
};

export default SegmentsPaymentServiceScreen;
